import { API_URL } from "../config";

// Every distributor-scoped data call needs a site_id (see QuickActionsSidebar's
// site switcher). Right after login/SSO entry, localStorage has no site_id yet
// -- QuickActionsSidebar resolves the default site async, which races any page
// that reads localStorage.site_id synchronously on mount. Pages that fetch
// site-scoped data should await this first instead of reading localStorage directly.
export async function getActiveSiteId() {
  const existing = localStorage.getItem("site_id");
  if (existing) return existing;

  const distributorId = localStorage.getItem("user_id");
  if (!distributorId) return null;

  try {
    const res = await fetch(`${API_URL}/distributor/site/${distributorId}`, {
      headers: { "x-access-token": localStorage.getItem("accessToken") },
    });
    const data = await res.json();
    if (data.status && Array.isArray(data.data) && data.data.length > 0) {
      const site = data.data[0];
      localStorage.setItem("site_id", site.site_id);
      localStorage.setItem("site_name", site.name);
      return site.site_id;
    }
  } catch (err) {
    console.error("Error resolving active site:", err);
  }
  return null;
}
